<template>
  <div
    class="dui-search-input input-group"
    :disabled="disabled"
  >
    <input
      ref="inputField"
      autocomplete="off"
      class="input-full"
      type="text"
      :value="value"
      @input="valueUpdated"
    >

    <span
      v-if="isPlaceholderDisplayed"
      class="placeholder"
    >{{ placeholder }}</span>

    <button
      v-if="(value && value.length)"
      class="button-sm button-icon"
      title="Clear"
      type="button"
      @click.stop.prevent="clearValue"
    >
      <DuiIconCross class="icon-sm" />
    </button>

    <DuiIconSearch
      v-else
      class="search-icon"
    />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    isPlaceholderDisplayed() {
      return !this.value;
    },
  },
  methods: {
    clearValue() {
      this.$refs.inputField.value = '';
      this.valueUpdated();
    },

    focus() {
      this.$refs.inputField.focus();
    },

    valueUpdated() {
      this.$emit('input', this.$refs.inputField.value);
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-search-input {
  overflow: hidden;
  position: relative;

  @include transition((
    border-color
  ));

  &:hover {
    border-color: getColor($grey, dark);
  }

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  &.input-full {
    width: 100%;
  }

  &.transparent {
    background-color: transparent;
    border: none;
    padding-left: 0;
    padding-right: 0;

    input {
      background-color: transparent;
      padding-left: 0;
      padding-right: $_4em;
    }

    .placeholder {
      color: getColor($grey, dark);
      left: 0;
    }

    .button-icon,
    .search-icon {
      right: 0;
    }
  }

  input {
    padding-right: $_5em;

    &::-ms-clear{
      display:none;
    }
  }

  .placeholder {
    left: $_2em;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }

  .button-icon,
  .search-icon {
    position: absolute;
    right: $_2em;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}
</style>
